import { SubscriptionPage } from "@/components/settings/subscription-page.tsx";
import { subTab } from "@/components/settings/subscription/subscription-tabs.ts";
import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/settings/org/subscription",
)({
	// Optional `?tab=` deep link (e.g. the dashboard billing card's
	// "See breakdown →" opens the Billing tab). Unknown values are dropped.
	validateSearch: z.object({
		// .catch(): a hand-tampered ?tab=xyz degrades to the default tab rather than
		// the route error boundary, matching every other tab surface.
		tab: subTab.optional().catch(undefined),
	}),
	component: SubscriptionPage,
	head: () => ({
		meta: [{ title: pageTitle("Subscription") }],
	}),
});
